import { useTranslation } from "react-i18next";

import { useDbpjkitWorkerJobDetail } from "~/features/dbpjkitWorkerJobs/hooks";
import { normalizeJob } from "~/features/dbpjkitWorkerJobs/utils/transformers";
import { DbpjkitWorkerJobDetailPresenter } from "./DbpjkitWorkerJobDetailPresenter";

interface DbpjkitWorkerJobDetailProps {
  id: string;
  onBack: () => void;
  variant?: "page" | "peek";
}

export function DbpjkitWorkerJobDetail({ id, onBack, variant = "page" }: DbpjkitWorkerJobDetailProps) {
  const { t } = useTranslation();
  const { data } = useDbpjkitWorkerJobDetail(id);

  const job = data.dbpjkitWorkerJobs[0];

  if (!job) {
    return <div className="text-[13px] text-fg-3">{t("ui.notFound")}</div>;
  }

  return (
    <DbpjkitWorkerJobDetailPresenter
      job={normalizeJob(job)}
      latestRun={job.dbpjkitWorkerJobRuns[0]}
      onBack={onBack}
      variant={variant}
    />
  );
}
